import type { IBrowserCheck } from "./IBrowserCheck";

export class BrowserCheck implements IBrowserCheck {
    public checkBrowserAndOutputWarning(): void {
        if (!window.atob) {
            // eslint-disable-next-line
            console.error("You are using an outdated browser, please update!");

            // Writes a pretty little error message for the people using an unsupported browser
            document.write(
                "<center><h1><center>Browser outdated</h1>" +
                    "Hello, we detected that you are using an outdated browser. Updating to a new browser is easy:<br/>" +
                    "<a href='https://browser-update.org/update-outdated.html'><strong>Read more here</strong></a><br />" +
                    "or download a browser directly:<br />" +
                    "<a href='https://www.mozilla.org/firefox'><strong>Firefox</strong></a><br />" +
                    "<a href='https://www.google.com/chrome'><strong>Chrome</strong></a><br />" +
                    "<a href='http://windows.microsoft.com/en-us/internet-explorer/download-ie'>" +
                    "<strong>Internet Explorer</strong></a><br/>" +
                    "<br/>Thanks from the Irisity Development team.</center><br/><br/>",
            );
        }
        // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
        if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
            const msViewportStyle = document.createElement("style");
            msViewportStyle.appendChild(document.createTextNode("@-ms-viewport{width:auto!important}"));
            document.querySelector("head").appendChild(msViewportStyle);
        }
    }
}
